import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from 'alm-react-components';
import {useTranslation} from 'react-i18next';


const InstructorView = ({instructors}: any) => {
  const {t} = useTranslation();
  const processedInstructorNames = new Set();

  // Create a new array to hold all instructors with their names and avatarUrls
  const allInstructors: {name: any; avatarUrl: any}[] = [];

  // Flatten the instructors array to create a single array of {name, avatarUrl} objects
  instructors.forEach((instructor: any) => {
    const instructorNames = instructor?.attributes?.instructorNames || [];
    const avatarUrls = instructor?.attributes?.avatarUrls || [];
    instructorNames.forEach((name: any, index: any) => {
      allInstructors.push({
        name,
        avatarUrl: avatarUrls[index] || avatarUrls[0],
      });
    });
  });

  // Sort the array by instructor names
  allInstructors.sort((a, b) => a.name.localeCompare(b.name));

  return (
    <div className="mt-12">
      {allInstructors.length === 0 ? (
        <div className="flex items-center justify-center h-full">
          <p className="text-center">
          <span dangerouslySetInnerHTML={{ __html: t("Instructors.noInstructorDetailsFound") }} /></p>
        </div>
      ) : (
        <Carousel>
          <CarouselContent className="md:flex-row max-md:flex-row max-sm:flex-row max-[380px]:flex-row md:gap-0 max-[380px]:gap-0">
            {allInstructors.map(({name, avatarUrl}, index) => {
              if (!processedInstructorNames.has(name)) {
                processedInstructorNames.add(name);

                return (
                  <CarouselItem
                    key={`${name}-${index}`}
                    className="landscape:2xl:basis-1/5 landscape:xl:basis-1/3 landscape:lg:basis-1/3 landscape:md:basis-1/3 portrait:md:basis-1/3 landscape:max-md:basis-1/3 portrait:max-md:basis-1/3  landscape:max-sm:basis-1/2 portrait:max-sm:basis-1/2 landscape:max-[380px]:basis-1/0 portrait:max-[380px]:basis-1/0 rounded-xl "
                  >
                    <Card
                      className="w-full h-full p-0 bg-fillMidGrayCard border-cardBorder relative overflow-hidden"
                      style={{width: '100%'}}
                    >
                      <CardHeader className="p-0">
                        <div className="relative">
                          <img
                            src={avatarUrl}
                            alt={`Avatar for ${name}`}
                            //className="object-fill rounded-xl w-full max-sm:h-[156px] max-md:h-[177px] md:h-[297px] basis-1/3"
                            className="w-full basis-1/3 object-cover object-top h-[156px] md:h-[240px] overflow-hidden"
                          />
                        </div>
                      </CardHeader>
                      <span className="absolute top-4 bg-white mx-3 p-1 px-2 font-barlowMedium text-black text-xs uppercase rounded">
                        <span dangerouslySetInnerHTML={{ __html: t('Instructors.instructorTitle') }} />
                      </span>
                      <CardContent className="absolute bottom-2 px-5 pb-0">
                        <div className="flex flex-row items-start justify-between mt-2 h-full">
                          <div className="flex flex-col justify-between">
                            <div className="flex flex-col">
                              <CardTitle className="text-wrap text-base leading-8 font-opensansMedium line-clamp-2 coaches-title">
                                {name}
                              </CardTitle>
                            </div>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  </CarouselItem>
                );
              }
              return null;
            })}
          </CarouselContent>
          <div className="carousel-prev-next-box">
            <CarouselPrevious className="carousel-prev-btn top-full mt-5 translate-y-0" />
            <CarouselNext className="carousel-next-btn right-0 top-full bottom-0 mt-5 translate-y-0" />
          </div>
        </Carousel>
      )}
    </div>
  );
};

export default InstructorView;
